import { addArrayListFilter } from '../../helpers/listHelper';
import { canSeeGiftAid, GiftAidAccess } from '../../helpers/giftAidHelper';

// Gift Aid only exists for United Kingdom charities, so these filters are
// added to the donation list at render time rather than to the static
// availableFiltersKeys.
export const giftAidFiltersKeys = [
  'donor.giftAid',
  'donor.giftAidClaim.status'
];

export const canFilterByGiftAid = canSeeGiftAid;

export const getListWithGiftAidFilters = <
  T extends { availableFiltersKeys: string[] }
>(
  list: T,
  access: GiftAidAccess
): T => {
  if (!list || !canFilterByGiftAid(access)) {
    return list;
  }
  return addArrayListFilter(list, giftAidFiltersKeys);
};
